<template>
  <div>
    <drawer :drawer="drawer" @drawer="setDrawer" />

    <v-main>
      <v-container class="page-content-container">
        <router-view />
      </v-container>
    </v-main>

    <offline-popup />
  </div>
</template>

<script>
import Drawer from '@/components/drawer/Drawer';
import OfflinePopup from '@/components/popup/OfflinePopup';

// @vuese
// Layout
// @group Layout
export default {
  components: { Drawer, OfflinePopup },
  props: {
    source: String
  },
  data: () => ({
    drawer: false
  }),
  methods: {
    // @vuese
    // Ustanowienie menu bocznego
    setDrawer(drawer) {
      this.drawer = drawer;
    }
  }
};
</script>
